import { HttpClient } from "@angular/common/http"
import { PermissionService } from "../core/services/permisson.service"
import { DefaultMethod } from "./common"
import { NotificationService } from "../notification.service"

let http: HttpClient
let toastr: NotificationService
let permissionService = new PermissionService(http, toastr)
let scViewPermit = permissionService.getViewPermissions('sc')
let ccViewPermit = permissionService.getViewPermissions('cc')
let agency_Advertiser_sidenav = [
  { name: "Basic Setup", id: "basic_step", active: true },
  { name: "Configuration", id: "config_step", active: true },
];
let basic_sidenav = [
  { name: "Basic Setup", id: "basic_step", active: true },
]
// if (scViewPermit || ccViewPermit) {
  agency_Advertiser_sidenav = agency_Advertiser_sidenav.concat(
    { name: "Commissions and Contracts", id: "commission_step", active: false })
    basic_sidenav = basic_sidenav.concat(
      { name: "Commissions and Contracts", id: "commission_step", active: false })
// }
agency_Advertiser_sidenav = agency_Advertiser_sidenav.concat(
  { name: "Account Balance", id: "credit_debit_step", active: false })
  basic_sidenav = basic_sidenav.concat(
    { name: "Account Balance", id: "credit_debit_step", active: false })


export const componentsSideMenuOptions = {
  insertionOrder: [
    { name: "Basic Setup", id: "io_basic_setup", active: true },
    // { name: "Frequency and Recency", id: "frequency_recency", active: true },
    { name: "Inventory Lists", id: "supply_strategy", active: false },
    // { name: "Political Advertisement", id: "political_advertisement" , active: true},
  ],
  insertionOrderPg: [
    { name: "Basic Setup", id: "io_basic_setup", active: true },
  ],
  NonApnxAgency:[
  { name: "Basic Setup", id: "basic_step", active: true },
  { name: "Configuration", id: "config_step", active: true },
  { name: "Account Balance", id: "credit_debit_step", active: false }
  ],
  nonApnxAdvertiser:[
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "Configuration", id: "config_step", active: true },
    { name: "Account Balance", id: "credit_debit_step", active: false }
    ],
  offlineAdvertiser:[
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "Configuration", id: "config_step", active: true },
    { name: "Commissions and Contracts", id: "commission_step", active: false },
    { name: "Offline Attribution Fees", id: "attribution_step", active: false },
    { name: "Account Balance", id: "credit_debit_step", active: false }
  ],
  offlineAgency:[
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "Configuration", id: "config_step", active: true },
    { name: "Commissions and Contracts", id: "commission_step", active: false },
    { name: "Offline Attribution Fees", id: "attribution_step", active: false },
    { name: "Account Balance", id: "credit_debit_step", active: false }
  ],
  financeAdvertiser:[
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "Commissions and Contracts", id: "commission_step", active: false },
  ],
  financeAgency:[
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "Commissions and Contracts", id: "commission_step", active: false },
  ],
  campaign: [
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "Conversion Pixel", id: "pixel_step", active: false },
    { name: "Creatives", id: "creative_step", active: false },
    { name: "Targeting", id: "targeting_step", active: false },
    { name: "Split", id: "split_step", active: false }
  ],
  pgDealOthersCampaign: [
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "Conversion Pixel", id: "pixel_step", active: false },
    { name: "Creatives", id: "creative_step", active: false },
    { name: "Deals", id: "targeting_step", active: false }
  ],
  pgDealNetflixCampaign: [
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "Creatives", id: "creative_step", active: false },
    { name: "Deals", id: "targeting_step", active: false }
  ],
  pmpNetflixCampaign: [
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "Conversion Pixel", id: "pixel_step", active: false },
    { name: "Creatives", id: "creative_step", active: false },
    { name: "Targeting", id: "targeting_step", active: false },
  ],
  politicalCampaign: [
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "Conversion Pixel", id: "pixel_step", active: false },
    { name: "Creatives", id: "creative_step", active: false },
    { name: "Targeting", id: "targeting_step", active: false }
  ],
  creatives: [
    { name: "Basic Setup", id: "creatives_content_step", active: true },
    { name: "Campaigns", id: "creatives_campaign_step", active: true },
    { name: "Segment Pixels", id: "creatives_segment_step", active: true }
  ],
  convertionPixel: [
    { name: "Basic Setup", id: "basic_step", active: true }
  ],
  platformAdmin: [
    { name: "Basic Setup", id: "basic_step", active: true }
  ],
  AccountManager: [
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "Agencies", id: "agency_step", active: false },
    { name: "Advertisers", id: "advertiser_step", active: false },
  ],
  Agency: agency_Advertiser_sidenav,
  Advertiser: agency_Advertiser_sidenav,
  LiteAdvertiser: basic_sidenav,
  'Agency Advertiser': [
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "Configuration", id: "config_step", active: false },
  ],
  'Political Agency Advertiser': [
    { name: "Basic Setup", id: "basic_step", active: true },
  ],
  'Adsp Agency Advertiser': [
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "Configuration", id: "config_step", active: false },
  ],
  'Bdsp Agency Advertiser': [
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "Configuration", id: "config_step", active: false },
  ],
  'Agency User': [
    { name: "Basic Setup", id: "basic_step", active: true },
    // { name: "Advertisers", id: "advertiser_step", active: false },
  ],
  'Advertiser User': [
    { name: "Basic Setup", id: "basic_step", active: true },
  ],
  'Deals': [
    { name: "Basic Setup", id: "basic_step", active: true },
    // { name: "Agencies", id: "agency_step", active: true },
    // { name: "Advertisers", id: "advertiser_step", active: true },
  ],
  'Segment Pixel':[
    { name: "Basic Setup", id: "basic_step", active: true },
  ],
  'Segment': [
    { name: "Basic Setup", id: "basic_step", active: true },
    // { name: "Agencies", id: "agency_step", active: false },
    // { name: "Advertisers", id: "advertiser_step", active: false },
    { name: "Upload History", id: "identifier_step", active: false },
  ],
  'Audience': [
    { name: "Basic Setup", id: "basic_step", active: true },
    // { name: "Agencies", id: "agency_step", active: false },
    // { name: "Advertisers", id: "advertiser_step", active: false },
    { name: "Upload audience", id: "identifier_step", active: false },
  ],
  'Third Party Segment': [
    { name: "Basic Setup", id: "basic_step", active: true },
    // { name: "Agencies", id: "agency_step", active: false },
    // { name: "Advertisers", id: "advertiser_step", active: false },
  ],
  'Inventory List': [
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "List Items", id: "list_items_step", active: false }
  ],
  'Custom Location': [
    { name: "Basic Setup", id: "basic_step", active: true },
  ],
  'Contract': [
    { name: "Basic Setup", id: "basic_step", active: true },
  ],
  'Site Engagement': [
    { name: "Basic Setup", id: "basic_step", active: true },
  ],
  'Ads Engagement': [
    { name: "Basic Setup", id: "basic_step", active: true },
  ],
  'File Upload': [
    { name: "Basic Setup", id: "basic_step", active: true },
  ],
  'Adsp Insertion Order': [
    { name: "Basic Setup", id: "basic_step", active: true},
    { name: "Conversion Trackers", id: "conversion_tracker_step", active: true},
  ],
  'Adsp Line Items': [
    { name: "Basic Setup", id: "basic_step", active: true},
    { name: "Targeting", id: "targeting_step", active: true },
    { name: "Creatives", id: "creative_step", active: true },
  ],
  'Adsp Creative': [
    { name: "Basic Setup", id: "basic_step", active: true },
  ],
  'Adsp Segment': [
    { name: "Basic Setup", id: "basic_step", active: true },
  ],
  'Adsp Events': [
    { name: "Basic Setup", id: "basic_step", active: true },
  ],
  'Adsp Conversion Tracker': [
    { name: "Basic Setup", id: "basic_step", active: true },
  ],
  'Adsp Deals': [
    { name: "Basic Setup", id: "basic_step", active: true },
  ],
  'Adsp Inventory List': [
    { name: "Basic Setup", id: "basic_step", active: true },
  ],
  'Coupon Code':[
    { name: "Basic Setup", id: "basic_step", active: true }
  ],
  'Store':[
    { name: "Basic Setup", id: "basic_step", active: true }
  ],
  bdspInsertionOrder: [
    { name: "Basic Setup", id: "basic_step", active: true}
  ],
  'Bdsp Events': [
    { name: "Basic Setup", id: "basic_step", active: true}
  ],
  'bdspCreative': [
    { name: "Basic Setup", id: "basic_step", active: true },
  ],
  'bdspNativeOffer': [
    { name: "Basic Setup", id: "basic_step", active: true },
  ],
  'bdspLineItem': [
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "Events", id: "event_step", active: false },
    { name: "Creatives", id: "creative_step", active: false },
    { name: "Delivery Modifiers", id: "dlv_step", active: false },
    { name: "Targeting", id: "targeting_step", active: false }
  ],
  'bdspSegment': [
    { name: "Basic Setup", id: "basic_step", active: true }
  ],
  'bdspSegmentUpload': [
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "Upload History", id: "identifier_step", active: true }
  ],
  'bdspCustomList': [
    { name: "Basic Setup", id: "basic_step", active: true }
  ],
  'bdspDlvModifier': [
    { name: "Basic Setup", id: "basic_step", active: true }
  ],
  'bdspLIBsc': [
    { name: "Basic Setup", id: "basic_step", active: true }
  ],
  'bdspLIBscEvt': [
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "Events", id: "event_step", active: false }
  ],
  'bdspLIBscEvtCrtv': [
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "Events", id: "event_step", active: false },
    { name: "Creatives", id: "creative_step", active: false }
  ],
  'bdspLIBscEvtTrgt': [
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "Events", id: "event_step", active: false },
    { name: "Targeting", id: "targeting_step", active: false }
  ],
  'bdspLIBscEvtCrtvTrgt': [
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "Events", id: "event_step", active: false },
    { name: "Creatives", id: "creative_step", active: false },
    { name: "Targeting", id: "targeting_step", active: false }
  ],
  'bdspLIBscCrtv': [
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "Creatives", id: "creative_step", active: false }
  ],
  'bdspLIBscCrtvTrgt': [
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "Creatives", id: "creative_step", active: false },
    { name: "Targeting", id: "targeting_step", active: false }
  ],
  'bdspLIBscTrgt': [
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "Targeting", id: "targeting_step", active: false }
  ],
  'bdspLIEvt': [
    { name: "Events", id: "event_step", active: true }
  ],
  'bdspLIEvtCrtv': [
    { name: "Events", id: "event_step", active: true },
    { name: "Creatives", id: "creative_step", active: false }
  ],
  'bdspLIEvtCrtvTrgt': [
    { name: "Events", id: "event_step", active: true },
    { name: "Creatives", id: "creative_step", active: false },
    { name: "Targeting", id: "targeting_step", active: false }
  ],
  'bdspLIEvtTrgt': [
    { name: "Events", id: "event_step", active: true },
    { name: "Targeting", id: "targeting_step", active: false }
  ],
  'bdspLICrtvTrgt': [
    { name: "Creatives", id: "creative_step", active: true },
    { name: "Targeting", id: "targeting_step", active: false }
  ],
  'bdspLITrgt': [
    { name: "Targeting", id: "targeting_step", active: true }
  ],
  'bdspLICrtv': [
    { name: "Creatives", id: "creative_step", active: true }
  ],
  'notifications': [
    { name: "Basic Setup", id: "basic_step", active: true }
  ],
  'bdspDeals': [
    { name: "Basic Setup", id: "basic_step", active: true }
  ],
  'TdspAppData': [
    { name: "Basic Setup", id: "basic_step", active: true },
  ],
  'TdspSegUpload': [
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "Upload History", id: "identifier_step", active: true }
  ],
  tdspAgencyAdvertiser: [
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "Configuration", id: "config_step", active: false },
  ],
  'tdspSeed': [
    { name: "Basic Setup", id: "basic_step", active: true }
  ],
  'tdspCampaign': [
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "Creatives", id: "creative_step", active: false },
    { name: "Targeting", id: "targeting_step", active: false }
  ],
  'tdspAudienceBuilder': [
    { name: "Basic Setup", id: "basic_step", active: true }
  ],
  'tdspCreative': [
    { name: "Basic Setup", id: "basic_step", active: true },
  ],
  tdspUniversalPixel: [
    { name: "Basic Setup", id: "basic_step", active: true }
  ],
  'tdspCustomLocation': [
    { name: "Basic Setup", id: "basic_step", active: true}
  ],
  tdspInsertionOrder: [
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "Seeds", id: "seed_step", active: false },
    { name: "Pixels & Trackers", id: "pixel_step", active: false }
  ],
  'Tdsp Inventory List':[
    { name: "Basic Setup", id: "basic_step", active: true },
    { name: "List Items", id: "list_items_step", active: false }
  ],
  'TdspInventoryCategory': [
    { name: "Basic Setup", id: "basic_step", active: true },
  ],
  'tdspCntKeywords': [
    { name: "Basic Setup", id: "basic_step", active: true },
  ],
  'tdspConversionPixel': [
    { name: "Basic Setup", id: "basic_step", active: true },
  ],
  'tdspDeals': [
    { name: "Basic Setup", id: "basic_step", active: true }
  ],
};

export const landingPageUrl = {
  insertionOrder: '/insertion-order',
  campaign: '/campaign',
  pgDealOthersCampaign: '/campaign',
  pgDealNetflixCampaign: '/campaign',
  politicalCampaign: "/campaign",
  pmpNetflixCampaign: "/campaign",
  creatives: '/creatives',
  convertionPixel: '/conversion-pixel',
  platformAdmin: '/platform-admin',
  AccountManager: '/account-manager',
  Agency: '/agency',
  Contract: '/contract',
  Advertiser: '/advertiser',
  LiteAdvertiser: '/advertiser',
  offlineAdvertiser: '/advertiser',
  offlineAgency: '/agency',
  financeAdvertiser: '/advertiser',
  "financeAgency": '/agency',
  'Agency Advertiser': '/agency-advertiser',
  'Adsp Agency Advertiser': '/adsp/agency-advertiser',
  'Bdsp Agency Advertiser': '/bdsp/agency-advertiser',
  'Political Agency Advertiser': '/agency-advertiser',
  'Agency User': '/user',
  'Advertiser User': '/user',
  'Deals': '/deals',
  'Segment': '/segment-pixel',
  'Segment Pixel':'/segment-pixel',
  'Third Party Segment': '/segment-pixel',
  'Inventory List': '/inventory',
  Audience:'/segment-pixel',
  'Custom Location': '/custom-location',
  'Site Engagement':'/site-engagement',
  'Ads Engagement': '/ads-engagement',
  'File Upload': '/file-upload',
  'Adsp Insertion Order': 'adsp/insertion-order',
  'Adsp Line Items': 'adsp/campaign',
  'Adsp Campaign': 'adsp/campaign',
  'Adsp Creative': '/adsp/creative',
  'Adsp Segment': '/adsp/segment-pixel',
  'Adsp Events': 'adsp/event',
  'Adsp Conversion Tracker': 'adsp/conversion-tracker',
  'Adsp Inventory List': 'adsp/inventory',
  'NonApnxAgency': '/agency',
  'nonApnxAdvertiser': '/advertiser',
  'Adsp Deals': '/adsp/deals',
  'insertionOrderPg': '/insertion-order',
  'Coupon Code': '/coupon-code',
  'Store': '/store',
  'Bdsp Events': 'bdsp/event',
  'bdspInsertionOrder': '/bdsp/insertion-order',
  'bdspCreative': 'bdsp/creative',
  'bdspLineItem': '/bdsp/campaign',
  'bdspSegment': '/bdsp/segment-pixel',
  'bdspSegmentUpload': '/bdsp/segment-pixel',
  'bdspCustomList': '/bdsp/custom-list',
  'bdspDlvModifier': '/bdsp/delivery-modifier',
  'bdspDeals': '/bdsp/deals',
  'bdspLIBsc': '/bdsp/campaign',
  'bdspLIBscEvt': '/bdsp/campaign',
  'bdspLIBscEvtCrtv': '/bdsp/campaign',
  'bdspLIBscEvtTrgt': '/bdsp/campaign',
  'bdspLIBscCrtvTrgt': '/bdsp/campaign',
  'bdspLIBscEvtCrtvTrgt': '/bdsp/campaign',
  'bdspLIBscCrtv': '/bdsp/campaign',
  'bdspLIBscTrgt': '/bdsp/campaign',
  'bdspLIEvt': '/bdsp/campaign',
  'bdspLIEvtCrtv': '/bdsp/campaign',
  'bdspLIEvtCrtvTrgt': '/bdsp/campaign',
  'bdspLIEvtTrgt': '/bdsp/campaign',
  'bdspLICrtv': '/bdsp/campaign',
  'bdspLICrtvTrgt': '/bdsp/campaign',
  'bdspLITrgt': '/bdsp/campaign',
  'notifications': 'platform-notification',
  'bdspNativeOffer': '/bdsp/creative',
  'tdspAgencyAdvertiser': '/tdsp/agency-advertiser',
  'tdspInsertionOrder': '/tdsp/insertion-order',
  'tdspSeed': '/tdsp/seed',
  'tdspCampaign': '/tdsp/campaign',
  'tdspAudienceBuilder': 'tdsp/audience-builder',
  'TdspAppData':"/tdsp/segments",
  'TdspSegUpload':"/tdsp/segments",
  'tdspCreative': 'tdsp/creative',
  'tdspUniversalPixel': '/tdsp/segments',
  'tdspCustomLocation': 'tdsp/custom-location',
  'Tdsp Inventory List': '/tdsp/inventory-list',
  'TdspInventoryCategory': '/tdsp/content-category',
  'tdspCntKeywords': 'tdsp/contextual-keywords',
  'tdspConversionPixel': 'tdsp/conversion-pixel',
  'tdspDeals': 'tdsp/deals'
};

export const defaultRole = {
  platform_superadmin: "/platform-admin",
  platform_admin: "/agency",
  account_manager: "/agency",
  agency_primary_admin: "/advertiser",
  agency_admin: "/advertiser",
  agency_user: "/advertiser",
  advertiser_primary_admin: '/campaign',
  advertiser_admin: '/campaign',
  advertiser_user: '/campaign',
  agency_reporting_user: '/advertiser',
  advertiser_reporting_user: '/campaign',
};

export class DefaultSideBar{
  campaign:DefaultMethod;
  custom_location:DefaultMethod;
  insertion_order: DefaultMethod;
  inventory_list: DefaultMethod;
  line_item:DefaultMethod;
  segment;
  segment_pixel;
  segment_upload;
  constructor(){
    this.inventory_list = new DefaultMethod();
    this.campaign = new DefaultMethod();
    this.line_item = new DefaultMethod();
    this.insertion_order = new DefaultMethod();
    this.custom_location = new DefaultMethod();
  }
}
